import service from '@/store/services/employers/station-tariff-service';

const state = {
    list: {},
    stationTariff: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, stationTariff) => {
        state.stationTariff = stationTariff;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(stationTariff => {
                commit('SET_RESOURCE', stationTariff);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(stationTariff => {
                commit('SET_RESOURCE', stationTariff);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((stationTariff) => {
                commit('SET_RESOURCE', stationTariff);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((stationTariff) => {
                commit('SET_RESOURCE', stationTariff);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    stationTariff: state => state.stationTariff,
    dropdown: (state) => {
        return state.list.map(station => ({
            id: station.id,
            name: station.name,
            short_name: station.short_name,
            code: station.code
        }));
    }
};

const stationTariffs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default stationTariffs;

